import React from 'react'
import { Card } from '@mui/material'
import { styled, Box } from '@mui/system'

const CardRoot = styled(Card)(() => ({
    height: '100%',
    padding: '20px 24px',
}))

const CardTitle = styled('div')(({ subtitle }) => ({
    fontSize: '1rem',
    fontWeight: 'bold',
    textTransform: 'capitalize',
    marginBottom: !subtitle && "16px",
}))

const StyledHR = styled('hr')(({ theme }) => ({
    borderTop: "1px solid #EBEDF3",
    margin: "25px 0"
}))

const SimpleCard = ({ children, title, subtitle, icon }) => {
    return (
        <CardRoot elevation={6} sx={{ marginTop: 2 }}>
            {title ? <CardTitle subtitle={subtitle}>
                {title}
            </CardTitle> : null}
            {subtitle && <Box sx={{ mb: 2 }}>{subtitle}</Box>}
            {title || subtitle ? <StyledHR /> : null}
            {children}
        </CardRoot>
    )
}

export default SimpleCard
